// removed by extract-text-webpack-plugin


//////////////////
// WEBPACK FOOTER
// ./src/styles/config_central.css
// module id = 2410
// module chunks = 0